import { AxiosResponse } from 'axios';
import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import { ListResult } from './ResultTypes/ListResult';
import { SubrecipeCost } from '@/models/RecipeCost/SubrecipeCost';

const resource = '/recipeCosts';

export default {
  listRecipeCosts(listRequest: ListRequest) {
    return Repository.post(`${resource}/ListRecipeCosts`, listRequest, { withCredentials: true });
  },
  searchRecipesWithCosts(searchTerm: string) {
    return Repository.post(`${resource}/SearchRecipesWithCosts`, { searchTerm }, { withCredentials: true });
  },
  deleteRecipeCost(id: number) {
    return Repository.post(`${resource}/DeleteRecipeCost`, { id: id }, { withCredentials: true });
  },
  createRecipeCost(recipeCost: any) {
    return Repository.post(`${resource}/CreateRecipeCost`, recipeCost, { withCredentials: true });
  },
  getRecipeCostDetails(recipeCostId: number) {
    return Repository.post(`${resource}/GetRecipeCostDetails`, { recipeCostId }, { withCredentials: true });
  },
  updateRecipeCost(recipeCost: any) {
    return Repository.post(`${resource}/UpdateRecipeCost`, recipeCost, { withCredentials: true });
  },
  listRecipeCostsForSubrecipes(recipeId: number) {
    return Repository.get<void, AxiosResponse<ListResult<SubrecipeCost>>>(`${resource}/ListRecipeCostsForSubrecipes?id=${recipeId}`, { withCredentials: true });
  },
};